import { ApiResponse } from "../types/common";
import {
  CreateUserAddressRequest,
  UpdateUserAddressRequest,
  UserActionResponse,
  UserAddress,
} from "../types/userAddress";

import { ApiClient } from "./apiClient";

const userAddressService = new ApiClient<UserAddress>("/UserAddress");

export const getUserAddresses = (): Promise<ApiResponse<UserAddress[]>> => {
  return userAddressService.getAll();
};

export const getAddressById = (
  addressId: string,
): Promise<ApiResponse<UserAddress>> => {
  return userAddressService.get(addressId);
};

export const getDefaultAddress = (): Promise<ApiResponse<UserAddress>> => {
  return userAddressService.custom("get", "/default");
};

export const createAddress = (
  addressData: CreateUserAddressRequest,
): Promise<ApiResponse<UserAddress>> => {
  return userAddressService.create(addressData);
};

export const updateAddress = (
  addressId: string,
  addressData: UpdateUserAddressRequest,
): Promise<ApiResponse<UserAddress>> => {
  return userAddressService.update(addressId, addressData);
};

export const deleteAddress = (
  addressId: string,
): Promise<ApiResponse<UserActionResponse>> => {
  return userAddressService.custom("delete", `/${addressId}`) as Promise<
    ApiResponse<UserActionResponse>
  >;
};

export const setDefaultAddress = (
  addressId: string,
): Promise<ApiResponse<UserAddress>> => {
  return userAddressService.custom("put", `/${addressId}/set-default`);
};

export default userAddressService;
